import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, LinearProgress } from "material-ui"
import FirestoreStore from "../../stores/FirestoreStore"
import strings from "../../localization/strings"
import firebase from "firebase"
import * as firebaseActions from "../../actions/FirebaseActions"
import firestoreStore from "../../stores/FirestoreStore"
let _db = null
let _unsubscribeProgress = null
let _showProgressTimeout = null
let _showProgress = false

// Required for side-effects
require("firebase/firestore")
interface IState {
	showProgress: boolean
	canceledShowProgress: boolean
	mainTitle: string
	currentActivity: string
	message: string
	masterProgressIndex: number
	masterProgressTotal: number
	subProgressIndex: number
	subProgressTotal: number
}

export default class LiveProgress extends React.Component<any, IState> {
	constructor(props) {
		super(props)
		this.state = {
			showProgress: false,
			canceledShowProgress: false,
			mainTitle: "",
			currentActivity: "",
			message: "",
			masterProgressIndex: 0,
			masterProgressTotal: 0,
			subProgressIndex: 0,
			subProgressTotal: 0
		}
		autobind(this)
		this.initAuth()
	}

	initAuth() {
		if (!_db && FirestoreStore.getAuthConfig()) {
			// Initialize Firebase
			const config = FirestoreStore.getAuthConfig()
			if (!firebase.apps.length) {
				firebase.initializeApp(config)
			} else {
				firebase.app(); // if already initialized, use that one
			}

			firebase.auth().signInWithCustomToken(config.firebaseAuthToken).then(() => {
				// Initialize Cloud Firestore through Firebase
				_db = firebase.firestore()
			})
		}
	}

	componentDidMount() {
		FirestoreStore.on("change", this.changeEvent)
		this.setupAsyncSession()
	}

	componentWillUnmount() {
		FirestoreStore.removeListener("change", this.changeEvent)
		this.unsubscribeAsyncSession()
	}

	setupAsyncSession() {
		if (_db && FirestoreStore.getAsyncSessionId()) {
			_unsubscribeProgress = _db.collection("payroll-progress").doc(FirestoreStore.getAsyncSessionId())
				.onSnapshot(doc => {
					const returnData = doc.data()
					if (returnData) {
						_showProgress = !returnData.done
						//beginning load operation. Only show progress after 2 seconds to avoid "flicker" on fast loading docs
						if (!this.state.showProgress && !returnData.done) {
							_showProgressTimeout = setTimeout(() =>
								this.setState({ showProgress: FirestoreStore.getAsyncSessionId() ? _showProgress : false })
								, 2000)
						}

						returnData.done && returnData.signedUrl &&
							firebaseActions.getUploadedDataFromSignedUrl(returnData.signedUrl, returnData.actionType, FirestoreStore.getAsyncSessionId())

						if (this.state.showProgress && returnData.done) {
							_showProgress = false
							clearTimeout(_showProgressTimeout)
							this.setState({ showProgress: _showProgress })
						}

						this.setState({
							mainTitle: returnData.mainTitle,
							currentActivity: returnData.currentActivity,
							message: returnData.message,
							masterProgressIndex: returnData.masterProgressIndex,
							masterProgressTotal: returnData.masterProgressTotal,
							subProgressIndex: returnData.subProgressIndex,
							subProgressTotal: returnData.subProgressTotal
						})
					}
				})
		}
		else {
			this.unsubscribeAsyncSession()
			this.setState({
				showProgress: false,
				canceledShowProgress: false
			})
		}
	}

	unsubscribeAsyncSession() {
		_unsubscribeProgress &&
			_unsubscribeProgress()
	}

	changeEvent() {
		this.initAuth()
		this.unsubscribeAsyncSession()
		this.setupAsyncSession()
	}

	render() {
		return (
			<span>
				{firestoreStore.getAsyncSessionId() && this.state.showProgress && !this.state.canceledShowProgress &&
					<Dialog
						modal
						title={this.state.mainTitle}
						open={this.state.showProgress}
						actions={[
							<FlatButton
								primary
								keyboardFocused
								label={strings.Close}
								onClick={() => {
									firebaseActions.clearAsyncSessionId()
									this.setState({ canceledShowProgress: true })
								}}
							/>
						]}
					>
						<div style={{ fontSize: 12 }}>{this.state.currentActivity}</div>
						<LinearProgress mode="determinate" value={this.state.masterProgressIndex} min={0} max={this.state.masterProgressTotal} />
						<div style={{ fontSize: 12, marginTop: 20 }}>{this.state.message}</div>
						<LinearProgress mode="determinate" value={this.state.subProgressIndex} min={0} max={this.state.subProgressTotal} />
					</Dialog>
				}
			</span>
		)
	}
}
